import { back, cubic, elastic, linear, quadratic, quartic, quintic } from '@juliendargelos/easings';
function getAllAnimationSeriesDuration(allAnimationSeries) {
    return Math.max(...Object.values(allAnimationSeries).map((animationSeries) => animationSeries.reduce((acc, tween) => acc + tween.durationMs, 0)));
}
/**
 * durationMultiplier, if provided, is a convenience to allow adjusting an entire animation's
 * duration with a single value.
 */
function createAdjustedAnimationSeries(allAnimationSeries, durationMultiplier) {
    if (!durationMultiplier) {
        return allAnimationSeries;
    }
    return Object.entries(allAnimationSeries).reduce((acc, [tweenTypeStr, anims]) => {
        acc[tweenTypeStr] = anims.map((tween) => ({
            ...tween,
            durationMs: tween.durationMs * durationMultiplier
        }));
        return acc;
    }, {});
}
function createAnimationSet(name, allAnimationSeries, { durationMultiplier } = {}) {
    const animations = createAdjustedAnimationSeries(allAnimationSeries, durationMultiplier);
    const totalDurationMs = getAllAnimationSeriesDuration(animations);
    return {
        name,
        animations,
        totalDurationMs
    };
}
export const CARD_SHOW_ANIMATION_SET = createAnimationSet('card-show', {
    scale: [{ startValue: 1.25, endValue: 1, durationMs: 500, fn: quadratic.out }],
    angle: [{ startValue: -15, endValue: 0, durationMs: 500, fn: cubic }],
    gamma: [
        {
            startValue: 4,
            endValue: 1,
            durationMs: 500,
            fn: cubic
        }
    ],
    contrast: [
        {
            startValue: 4,
            endValue: 1,
            durationMs: 500,
            fn: cubic
        }
    ]
});
export const SIDE_BET_ANIMATION_SET = createAnimationSet('side-bet', {
    scale: [
        { startValue: 1, endValue: 1.75, durationMs: 200, fn: quadratic.out },
        { startValue: 1.75, endValue: 0.5, durationMs: 800, fn: quadratic.in }
    ],
    angle: [
        { startValue: 0, endValue: -20, durationMs: 200, fn: cubic.out },
        { startValue: -20, endValue: 30, durationMs: 800, fn: cubic.in }
    ]
}, { durationMultiplier: 1.2 });
export const SIDE_BET_NAME_ANIMATION_SET = createAnimationSet('side-bet-name', {
    scale: [
        { startValue: 1.2, endValue: 1.5, durationMs: 400, fn: quadratic.out },
        { startValue: 1.5, endValue: 0.5, durationMs: 600, fn: quadratic.in }
    ]
}, { durationMultiplier: 1.2 });
export const CHAT_BUBBLE_ANIMATION_SET = createAnimationSet('chat-bubble', {
    scale: [
        {
            startValue: 1.25,
            endValue: 1,
            durationMs: 250,
            fn: quintic.out
        },
        {
            startValue: 1,
            endValue: 1,
            durationMs: 5000
        }
    ]
});
export const SIDE_BET_TARGET_ANIMATION_SET = createAnimationSet('side-bet-target', {
    scale: [
        {
            startValue: 0.8,
            endValue: 1,
            durationMs: 500,
            fn: elastic.out
        }
    ]
});
export const PLAYER_WIN_ANIMATION_SET = createAnimationSet('player-win', {
    scale: [
        {
            startValue: 2,
            endValue: 1,
            durationMs: 700,
            fn: back.out
        }
    ]
});
export const MY_TURN_CONTROLS_ANIMATION_SET = createAnimationSet('my-turn-controls', {
    y: [
        {
            startValue: 20,
            endValue: 0,
            durationMs: 250,
            fn: quintic.out
        }
    ]
});
export const CARD_RANKED_ANIMATION_SET = createAnimationSet('card-ranked', {
    y: [
        {
            startValue: 0,
            endValue: -60,
            durationMs: 500,
            fn: back.out
        }
    ]
});
/**
 * Used to 'reset' the card position if it was previously animated as a 'ranked' card.
 * (For example when a side pot is animated.)
 */
export const CARD_NON_RANKED_ANIMATION_SET = createAnimationSet('card-non-ranked', {
    y: [
        {
            startValue: 0,
            endValue: 0,
            durationMs: 0,
            fn: linear
        }
    ]
});
export const HAND_START_TABLE_ANIMATION_SET = createAnimationSet('hand-start-table', {
    y: [
        {
            startValue: 0,
            endValue: -10,
            durationMs: 200,
            fn: quartic.out
        },
        {
            startValue: -10,
            endValue: 0,
            durationMs: 400,
            fn: cubic.in
        }
    ]
});
export const PLAYER_TURN_USERNAME_ANIMATION_SET = createAnimationSet('player-turn-username-animation', {
    y: [
        {
            startValue: 15,
            endValue: 0,
            durationMs: 500,
            fn: back.out
        }
    ]
});
